import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isClassDerivedDeviceEnabledType } from '@iotv/datamodel';
import { EntityProgramme, EntityProgrammeSet, isEntityProgrammeConstructorProps, isEntityProgrammeSetConstructorProps, } from '@iotv/datamodel-core';
import { AppValueTypes, isNode } from '@iotv/iotv-v3-types';
import { deviceEnabledTypes } from '@iotv/payload-definition';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Card, CardContent, Tab } from '@mui/material';
import { Stack } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getViewDefintionFromObject } from '../../../../../../components/factories/AttributeDefinitions';
import { NodeEdgeMapperContext } from '../../../../../../ContextProviders/NodeEdgeMapperComponentContext';
import { DeviceControlDAO } from '../../../../../../data/DeviceControlDAO';
import { isAdminRole } from '../../../../../../helpers/access';
import { useTabHandlerStringKeys } from '../../../../../../hooks/useTabHandler';
import { ObjectDetailCard } from '../../../ObjectView/ObjectDetailCard';
import { GroupOperationalStatusInternal } from '../../GroupOperationalStatus/Components/GroupOperationalStatusInternal';
import { EntityProgrammeSetContext, } from '../Reducers/EntityProgrammeSetReducer';
import { EntityControlState } from './Tabs/EntityControlState';
import { EntityProgrammesTab } from './Tabs/EntityProgrammes';
import { EntityScheduledStatus } from './Tabs/EntityScheduledStatus';
const debug = process.env.REACT_APP_DEBUG && false;
export const EntityProgrammeSetInternal = (props) => {
    const { viewObject, userSelectedGroup, transactionFunctions: TransactionFunctions, userFunctions: UserFunctions, allowedActions } = props;
    const canaryString = 'EntityProgrammeSetInternal';
    const [state, dispatch] = useContext(EntityProgrammeSetContext);
    const navigate = useNavigate();
    //const [{ userSelectedGroup, TransactionFunctions, UserFunctions }] = useContext(AppMainViewContext)
    const { state: { nemHash, nodeEdgeMapper }, dispatch: nodeEdgeMapperDispatch, } = useContext(NodeEdgeMapperContext);
    const { matchedPrimary } = viewObject;
    useEffect(() => {
        if (matchedPrimary?.type === 'EntityProgrammeSet' && isEntityProgrammeSetConstructorProps(matchedPrimary)) {
            const action = {
                type: 'SetProgrammeSet',
                value: { programmeSet: new EntityProgrammeSet(matchedPrimary) },
            };
            dispatch(action);
            dispatch({
                type: 'SetProgrammeSetLoading',
                value: { programmeSetLoading: false },
            });
        }
        else {
            if (matchedPrimary) {
                console.log(`WARN: EntityProgrammeSetInternal not setting ProgrammeSet because`, matchedPrimary, isEntityProgrammeSetConstructorProps(matchedPrimary));
            }
        }
    }, [matchedPrimary?.sk]);
    const viewDefinition = matchedPrimary ? getViewDefintionFromObject(matchedPrimary) : {};
    viewDefinition.supportedType = {
        key: 'supportedType',
        editable: true,
        label: 'Supported Type',
        defaultValue: matchedPrimary?.supportedType,
        type: AppValueTypes.ENUM,
        enumKV: Object.fromEntries(Object.keys(deviceEnabledTypes).map((k) => [k, k])),
    };
    /** WARNING THIS IS DELIBERATELY CANONICALLY WRONG, but as GroupOperationalStatusInternal is used in LSC ObjectView as an injected tab, it needs a viewObjet as input
     * so until refactored  the operationalStatusTabViewObject is created from all entites in nodeEdgeMapper,
     */
    const operationalStatusTabViewObject = matchedPrimary && {
        matchedPrimary,
        matchedRelatedByPk: [],
        matchedRelatedBySk: nodeEdgeMapper.getContainedItems().filter(isNode).filter(isClassDerivedDeviceEnabledType),
    };
    debug && console.log(`INFO: operationalStatusTabViewObject`, { matchedPrimary, operationalStatusTabViewObject, nodeEdgeMapper });
    const tabDefinitions = {
        Programmes: () => _jsx(EntityProgrammesTab, { ...props }),
        'Schedule Status': () => _jsx(EntityScheduledStatus, {}),
        Transactions: () => _jsx(EntityControlState, { entity: matchedPrimary }),
        'Operational Status': () => operationalStatusTabViewObject ? _jsx(GroupOperationalStatusInternal, { viewObject: operationalStatusTabViewObject }) : null,
        Details: () => matchedPrimary ? (_jsx(ObjectDetailCard, { matchedPrimary,
            viewDefinition,
            mostProximateCustomer: undefined,
            transactionFunctions: TransactionFunctions,
            userFunctions: UserFunctions,
            allowedActions })) : null,
    };
    const tabsToDisplay = tabDefinitions;
    const { state: [[tabValue, setTabValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabsToDisplay);
    debug && console.log();
    useEffect(() => {
        const { programmeSet } = state;
        if (programmeSet) {
            if (!programmeSet.supportedType) {
                console.log(`WARN: No supportedType on rolling programme, redirecting to Details tab`);
                navigate(`${location.pathname}?tabName=Details`);
            }
            const apexNodeAction = { type: 'setApexNode', value: { apexNode: programmeSet } };
            nodeEdgeMapperDispatch(apexNodeAction);
            DeviceControlDAO.device.control.programme.sequential.getContext({ entityProgrammeSet: programmeSet }).then(({ err, data }) => {
                if (data) {
                    const { nodeEdgeMapper, apexNode } = data;
                    const action = { type: 'loadNEMContents', value: { canaryString, nodeEdgeMapper } };
                    nodeEdgeMapperDispatch(action);
                    dispatch({
                        type: 'SetProgrammesLoading',
                        value: { programmesLoading: false },
                    });
                }
            });
        }
    }, [state.programmeSet?.sk /*nemHash*/]);
    useEffect(() => {
        if (nodeEdgeMapper) {
            const programmes = nodeEdgeMapper
                .getNodesOfType('EntityProgramme')
                .filter(isEntityProgrammeConstructorProps)
                .map((item) => new EntityProgramme(item));
            const action = {
                type: 'SetProgrammes',
                value: { programmes },
            };
            debug && console.log('EntityProgrammeSetInternal dispatching programmes', nodeEdgeMapper.getSummary());
            dispatch(action);
        }
    }, [nemHash]);
    return (
    // unsetting overflow (on the container) is required to make `position: sticky` work
    isAdminRole(userSelectedGroup) ? (_jsx(Card, { elevation: 3, sx: { overflow: 'unset' }, children: _jsx(CardContent, { children: _jsxs(TabContext, { value: tabValue, children: [_jsx(TabList, { onChange: handleTabChange, children: Object.entries(tabsToDisplay)
                            .filter(([_, RFC]) => RFC !== null)
                            .map(([tabName, _RFC], i) => (_jsx(Tab, { value: tabName, label: tabName }, `tabHeader_${i}`))) }), Object.entries(tabsToDisplay)
                        .filter(([_, c]) => !!c)
                        .map(([k, component]) => (_jsx(TabPanel, { value: k, sx: { padding: 0, paddingBlockStart: 1 }, children: component() }, `tabBase_${k}`)))] }) }) })) : (_jsxs(Stack, { gap: 1, children: [_jsx(EntityProgrammesTab, { ...props }), _jsx(EntityScheduledStatus, {})] })));
};
